import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button, HeadingWithBackground, AboutBox } from "../";
import { Main } from "../../styles/";
import { CONTACTS_ROUTE } from "../../utils/constants";

const StyledHome = styled(Main)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Home = () => {
  return (
    <StyledHome>
      <HeadingWithBackground color="#2f9dd9">Денис</HeadingWithBackground>
      <AboutBox margin="4rem 0 0 0" />
      <Button size="large" as={Link} to={CONTACTS_ROUTE} margin="6rem 0 0 0">
        связаться со мной
      </Button>
    </StyledHome>
  );
};
